<template>
  <div style="width: 100%">
    <div style="width: 100%; max-height: 300px">
      <t-table ref="tableRef" :scroll="{ x: 3500 }" :data="messages" max-height="300px" :show-header="false">
        <t-table-column prop="msg" :label="$t('resource.txt.checkInfo')">
          <template #default="{ row }">
            <t-alert
              :type="type"
              :show-icon="true"
              :closable="false"
              :title="`${row.Message}`"
              style="font-size: 12px; line-height: 18px; white-space: pre-line"
            />
          </template>
        </t-table-column>
      </t-table>
    </div>
    <div style="width: 100%; height: 45px" class="pt-2">
      <span class="float-right" style="right: 15px">
        <t-button v-if="!isOkCancel" type="primary" @click="$emit('ok')">
          {{ $t('resource.button.sure') }}
        </t-button>
        <t-button v-if="isOkCancel" type="primary" @click="$emit('ok')">
          {{ $t('resource.button.continue') }}
        </t-button>
        <t-button v-if="isOkCancel" type="primary" @click="$emit('cancel')">
          {{ $t('resource.button.aborted') }}
        </t-button>
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ValidMsg',
    props: {
      isOkCancel: { type: Boolean, default: () => false },
      type: { type: String, default: () => 'error', required: true },
      messages: { type: Array, default: () => [], required: true }
    },
    mounted() {
      // this.$refs['tableRef'].loadData(this.messages)
    }
  }
</script>

<style scoped>
  ::v-deep .el-table__row > td {
    border: none !important;
  }

  ::v-deep .el-table::before {
    height: 0 !important;
  }

  ::v-deep .el-table tbody tr:hover > td {
    background-color: #fff !important;
  }

  ::v-deep .el-alert__icon {
    padding-right: 4px !important;
    font-size: 24px !important;
  }

  ::v-deep .el-alert {
    padding: 5px !important;
  }

  ::v-deep .el-alert__title {
    margin-left: 8px;
    color: #606266;
    size: 14px;
  }
</style>
